import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-acesso',
  templateUrl: './acesso.component.html',
  styleUrls: ['./acesso.component.scss']
})
export class AcessoComponent implements OnInit {

    refs: Observable<any[]>[] = [];
    lasts = {};
    userToPrint = null;
    userTime;
    users = {};
    constructor(public router: Router, private db: AngularFireDatabase) { }

    ngOnInit() {
        this.db.database.ref('acesso/funcionarios').once('value').then(data => {

            const funcs = [];
            data.forEach(u => {
                this.users[u.key] = u.val();
                this.users[u.key].id = u.key;
                funcs.push(u.key);
            });

            for (const i in funcs) {
                if (!funcs[i]) {
                    continue;
                }
                // console.log("Aqui");
                const key = funcs[i];
                const ref = this.db.list(`acesso/registro/${key}`, refs =>
                refs.orderByChild('createdAt').limitToLast(1)).snapshotChanges();
                ref.subscribe(x => {
                    if (x.length) {
                        const created = x[0].payload.val()['createdAt'];
                        const user = key;
                        console.log(user, created);
                        if (this.lasts[user] && this.lasts[user] !== created) {
                            this.getUserPrint(user, created);
                        }
                        this.lasts[user] = created;
                    }
                });
                this.refs.push(ref);
            }
        });

    }

    getUserPrint(user, t) {
        if (this.users[user]) {
            this.userToPrint = this.users[user];
            this.userTime = t;
            setTimeout(() => {this.userToPrint = null; }, 8000);
        }
    }


    format(x) {
        x = x + '';
        if (x.length === 1) {
          x = '0' + x;
        }
        return x;
      }

    getDate(x) {
        const d = new Date(x);
        const dia = d.getDate();
        const mes = d.getMonth() + 1;
        const ano = d.getFullYear();

        const hora = d.getHours();
        const minuto = d.getMinutes();
        const segundo = d.getSeconds();

        return this.format(dia) + '/' + this.format(mes) + '/' + ano + ' - ' + this.format(hora) + ':' +
          this.format(minuto) + ':' + this.format(segundo);
      }

}
